/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChangeRoleRequest } from '../../models/change-role-request';
import { OrganizationUserDto } from '../../models/organization-user-dto';

export interface OrganizationMembersOrganizationUserIdRolePut$Plain$Params {
  organizationUserId: string;
      body?: ChangeRoleRequest
}

export function organizationMembersOrganizationUserIdRolePut$Plain(http: HttpClient, rootUrl: string, params: OrganizationMembersOrganizationUserIdRolePut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<OrganizationUserDto>> {
  const rb = new RequestBuilder(rootUrl, organizationMembersOrganizationUserIdRolePut$Plain.PATH, 'put');
  if (params) {
    rb.path('organizationUserId', params.organizationUserId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OrganizationUserDto>;
    })
  );
}

organizationMembersOrganizationUserIdRolePut$Plain.PATH = '/organization/members/{organizationUserId}/role';
